import { Navigate, ScrollRestoration } from 'react-router-dom';
import { Outlet } from 'react-router';
import { ErrorBoundary } from 'src/components/error-boundary/error-boundary';
import { AuthProvider } from 'src/auth/context';
import { SubscriptionProvider } from 'src/context/subscription-context';
import { PlatformEditionProvider } from 'src/context/platform-edition-context';
import { DEVELOPMENT } from 'src/config-global';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { designRoutes } from './design';
import { oauthRoutes } from './oauth';
import { appRoutes } from 'src/routes/sections/app';
import { BillingCheckoutProvider } from 'src/context/billing-checkout-context';

// ----------------------------------------------------------------------

export const routes = [
  {
    path: '/',
    element: (
      // To use UseNavigate in AuthProvider, we need to put AuthProvider inside RouterProvider
      <AuthProvider>
        <PlatformEditionProvider>
          <ErrorBoundary>
            <SubscriptionProvider>
              <BillingCheckoutProvider>
                <ScrollRestoration />
                <Outlet />
              </BillingCheckoutProvider>
            </SubscriptionProvider>
          </ErrorBoundary>
        </PlatformEditionProvider>
      </AuthProvider>
    ),
    children: [
      // Auth routes
      ...authRoutes,

      // Design sandbox (dev-only, no auth) — /_design
      ...(DEVELOPMENT ? designRoutes : []),

      // OAuth consent for AI apps (MCP)
      ...oauthRoutes,

      // App routes
      ...appRoutes,

      // Main routes
      ...mainRoutes,

      // No match 404
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];
